import { useEffect } from 'react'
import clsx from 'clsx'
import { NavLink, Outlet } from 'react-router-dom'
import { useLazyQuery, gql } from '@apollo/client'
import { useReactiveVar } from '@apollo/client'

import { apolloOfferingStatusData } from '../services/apollo'

import {
  AdminNewOffering,
  AdminViewRegistrants,
  AdminUnlockContent,
  AdminEndOffering,
} from '../components'

const tabs = [
  { name: 'New TMC Offering', Component: AdminNewOffering, to: 'new' },
  { name: 'View Registrants', Component: AdminViewRegistrants, to: 'view' },
  {
    name: 'Unlock Weekly Content',
    Component: AdminUnlockContent,
    to: 'unlock',
  },
  { name: 'End Current Offering', Component: AdminEndOffering, to: 'end' },
]

const GET_OFFERINGS = gql`
  query GetOfferings {
    offerings(first: 1) {
      edges {
        node {
          databaseId
        }
      }
    }
  }
`

const Admin = () => {
  const [getOfferings, { data: offeringsData }] = useLazyQuery(GET_OFFERINGS, {
    fetchPolicy: 'no-cache',
  })
  const offeringStatus = useReactiveVar(apolloOfferingStatusData)
  const offerings = offeringsData?.offerings?.edges ?? []
  const offeringCount = offerings.length

  useEffect(() => {
    getOfferings().then((_offeringsData) => {
      if (_offeringsData && _offeringsData.data?.offerings?.edges?.length > 0) {
        apolloOfferingStatusData({ created: true })
      }
    })
  }, [getOfferings])

  /**
   * Refetch offering data whenever there's a offering reset signal
   * This will enable/disable admin tabs accordingly
   */
  useEffect(() => {
    getOfferings()
  }, [getOfferings, offeringStatus.created])

  return (
    <main className="min-h-[calc(100vh-200px)]">
      <div className="container mb-[120px] max-w-screen-home pt-14 lg:px-0">
        <div className="flex flex-col items-center pb-[10px]">
          <h1 className="mb-10 text-center text-4xl font-bold text-skin-accent">
            admin panel.
          </h1>
          {/** Panel */}
          <div className="flex w-full flex-col items-center divide-y divide-light-gray rounded-[19px] bg-white pt-2 shadow-lg lg:w-4/5">
            {/** Header */}
            <div className="py-4 text-sm font-bold text-flame">
              Hello, Administrator
            </div>
            {/** Tabs */}
            <div className="flex min-h-[630px] w-full flex-col lg:flex-row">
              <div
                className="grid grid-cols-1 justify-items-stretch sm:grid-cols-2 md:grid-cols-4 lg:flex lg:flex-col lg:flex-wrap"
                role="tablist"
                aria-orientation="vertical"
              >
                {tabs.map((tab, tabIndex) => (
                  <NavLink
                    key={tab.name}
                    as={NavLink}
                    preventScrollReset={true}
                    to={tab.to}
                    className={({ isActive }) =>
                      clsx(
                        'border-r-[1px] border-b-[1px] border-b-light-gray border-r-light-gray px-6 py-4 text-start text-xs lg:w-[230px] lg:border-r-0',
                        isActive ? 'bg-dark-gray text-white' : '',
                        offeringCount === 0 &&
                          tabIndex > 0 &&
                          'pointer-events-none opacity-50'
                      )
                    }
                    role="tab"
                    aria-selected="true"
                    tabIndex="0"
                  >
                    {tab.name}
                  </NavLink>
                ))}
              </div>
              <div className="flex grow flex-col border-l-[1px] border-l-light-gray py-[2.5rem] px-[1rem] text-xs sm:px-[2.75rem]">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default Admin
